"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContext = void 0;
exports.TabProvider = TabProvider;
exports.tabLabels = exports.tabIcons = exports.tabComponents = exports.tabApps = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Profile = _interopRequireDefault(require("../tabs/Profile"));
var _Security = _interopRequireDefault(require("../tabs/Security"));
var _Charge = _interopRequireDefault(require("../tabs/Charge"));
var _Notifications = _interopRequireDefault(require("../tabs/Notifications"));
var _Plans = _interopRequireDefault(require("../tabs/Plans"));
var _Certificates = _interopRequireDefault(require("../tabs/Certificates"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var tabComponents = {
  profile: _Profile["default"],
  security: _Security["default"],
  charge: _Charge["default"],
  notifications: _Notifications["default"],
  plans: _Plans["default"],
  certificates: _Certificates["default"]
};
exports.tabComponents = tabComponents;
var tabIcons = {
  profile: 'faUserAlt',
  security: 'faLock',
  charge: 'faDollarSign',
  notifications: 'faBell',
  plans: 'faPenAlt',
  certificates: 'faShieldAlt'
};
exports.tabIcons = tabIcons;
var tabLabels = {
  profile: 'Perfil',
  security: 'Segurança',
  charge: 'Cobrança',
  notifications: 'Notificações',
  plans: 'Planos',
  certificates: 'Certificados'
};
exports.tabLabels = tabLabels;
var tabApps = {
  profile: 'all',
  security: 'all',
  charge: 'all',
  notifications: 'all',
  plans: 'all',
  certificates: 'collectame'
};

/**
 * @typedef Tab
 * @type {keyof tabComponents}
 */
exports.tabApps = tabApps;
var TabContext = (0, _react.createContext)({
  /** @type {Tab} */
  tab: 'profile',
  /**
   * @param {Tab} tab
   * @param {any=} props
   **/
  setTab: function setTab(tab) {
    console.log('setTab');
  },
  /** @type {(props: any) => JSX.Element} */
  TabComponent: tabComponents.profile,
  /** @type {any} */
  tabProps: {},
  tabIcon: 'faProfile'
});
exports.TabContext = TabContext;
function TabProvider(_ref) {
  var children = _ref.children;
  /** @type {[Tab, React.Dispatch<React.SetStateAction<Tab>>]} */
  var _useState = (0, _react.useState)('profile'),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    tab = _useState2[0],
    setTab = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    tabProps = _useState4[0],
    setTabProps = _useState4[1];
  var TabComponent = tabComponents[tab];
  var tabIcon = tabIcons[tab];

  /**
   * @param {Tab} newTab
   * @param {any} tabProps
   */
  var handleTabChange = function handleTabChange(newTab) {
    var tabProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    setTab(newTab);
    setTabProps(tabProps);
  };
  return /*#__PURE__*/_react["default"].createElement(TabContext.Provider, {
    value: {
      tab: tab,
      setTab: handleTabChange,
      TabComponent: TabComponent,
      tabProps: tabProps,
      tabIcon: tabIcon
    }
  }, children);
}
TabProvider.propTypes = {
  app: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired
};